{
  "flows": {
    "addToCart": {
      "steps": [
        {
          "action": "showToast",
          "params": {
            "message": "Item added to cart!",
            "variant": "success"
          },
          "type": "basic"
        }
      ],
      "trigger": "event"
    },
    "cardProductMount": {
      "steps": [],
      "trigger": "lifecycle"
    }
  }
}
